/* React hooks */
import { createContext, useState } from "react";


const DataContext = createContext({ });

export const DataProvider = ({ children }) => {
    const [ activityList, setActivityList ] = useState([] );
    const [ activityInfos, setActivityInfos ] = useState([] );
    const [ agencySite, setAgencySite ] = useState([] );
    const [ agencyDefaultDeceasedImage, setAgencyDefaultDeceasedImage ] = useState([] );
    const [ agencyMainInfos, setAgencyMainInfos ] = useState([] );
    const [ agencyRelation, setAgencyRelation ] = useState([] );
    const [ agencyManager, setAgencyManager ] = useState([] );
    const [ agencyContact, setAgencyContact ] = useState([] );
    const [ agencyBilling, setAgencyBilling ] = useState([] );
    const [ agencyList, setAgencyList ] = useState([] );
    const [ agencyUserList, setAgencyUserList ] = useState([] );
    const [ agencyData, setAgencyData ] = useState([] );
    const [ billingAgencyList, setBillingAgencyList ] = useState([] );
    const [ billingSearchList, setBillingSearchList ] = useState([] );
    const [ billingInfos, setBillingInfos ] = useState([] );
    const [ billingMonthList, setBillingMonthList ] = useState([] );
    const [ billingLastMonthList, setBillingLastMonthList ] = useState([] );
    const [ billingSettings, setBillingSettings ] = useState([] );
    const [ cities, setCities ] = useState([]);
    const [ cmsTextInfos, setCmsTextInfos ] = useState([] );
    const [ cmsCookiesList, setCmsCookiesList ] = useState([] );
    const [ cmsFormList, setCmsFormList ] = useState([] );
    const [ cmsFormInfos, setCmsFormInfos ] = useState([] );
    const [ cmsLegalInfos, setCmsLegalInfos ] = useState([] );
    const [ cmsLegalList, setCmsLegalList ] = useState([] );
    const [ cmsPersonalDataInfos, setCmsPersonalDataInfos ] = useState([] );
    const [ cmsPersonalDataList, setCmsPersonalDataList ] = useState([] );
    const [ cmsStepList, setCmsStepList ] = useState([] );
    const [ cmsStepInfos, setCmsStepInfos ] = useState([] );
    const [ countryList, setCountryList ] = useState([]);
    const [ data, setData ] = useState([]);
    const [ dataList, setDataList ] = useState([]);
    const [ documentList, setDocumentList ] = useState([]);
    const [ documentInfos, setDocumentInfos ] = useState([]);
    const [ documentTypeList, setDocumentTypeList ] = useState([]);
    const [ emailList, setEmailList ] = useState([] );
    const [ emailInfos, setEmailInfos ] = useState([] );
    const [ ensembleList, setEnsembleList ] = useState([] );
    const [ estimateCategoryInfos, setEstimateCategoryInfos ] = useState([] );
    const [ estimateCategoryList, setEstimateCategoryList ] = useState([] );
    const [ estimateContentInfos, setEstimateContentInfos ] = useState([] );
    const [ estimateDetails, setEstimateDetails ] = useState([] );
    const [ estimateLine, setEstimateLine ] = useState([] );
    const [ estimateSectionList, setEstimateSectionList ] = useState([] );
    const [ estimateSelectedSection, setEstimateSelectedSection ] = useState([] );
    const [ formId, setFormId ] = useState("");
    const [ funerariumInfos, setFunerariumInfos ] = useState([]);
    const [ galleryContent, setGalleryContent ] = useState([]);
    const [ htmlInputContent, setHtmlInputContent ] = useState([] );
    const [ imageLib, setImageLib ] = useState([] );
    const [ singleImage, setSingleImage ] = useState([] );
    const [ legalFormList, setLegalFormList ] = useState([] );
    const [ networkContact, setNetworkContact ] = useState([] );
    const [ networkList, setNetworkList ] = useState([] );
    const [ networkMainInfos, setNetworkMainInfos ] = useState([] );
    const [ newProductList, setNewProductList ] = useState([] );
    const [ productInfos, setProductInfos ] = useState({} );
    const [ productList, setProductList ] = useState([]);
    const [ selectedCity, setSelectedCity ] = useState([] );
    const [ selectedBirthplace, setSelectedBirthplace ] = useState([] );
    const [ selectedDeathplace, setSelectedDeathplace ] = useState([] );
    const [ userInfos, setUserInfos ] = useState([] );

    return (
        <DataContext.Provider value={{
            activityInfos, setActivityInfos,
            activityList, setActivityList,
            agencyList, setAgencyList,
            agencyUserList, setAgencyUserList,
            agencyData, setAgencyData,
            agencySite, setAgencySite,
            agencyMainInfos, setAgencyMainInfos,
            agencyDefaultDeceasedImage, setAgencyDefaultDeceasedImage,
            agencyRelation, setAgencyRelation,
            agencyManager, setAgencyManager,
            agencyContact, setAgencyContact,
            agencyBilling, setAgencyBilling,
            billingAgencyList, setBillingAgencyList,
            billingInfos, setBillingInfos,
            billingLastMonthList, setBillingLastMonthList,
            billingMonthList, setBillingMonthList,
            billingSettings, setBillingSettings,
            billingSearchList, setBillingSearchList,
            cities, setCities,
            cmsTextInfos, setCmsTextInfos,
            cmsCookiesList, setCmsCookiesList,
            cmsFormList, setCmsFormList,
            cmsFormInfos, setCmsFormInfos,
            cmsLegalInfos, setCmsLegalInfos,
            cmsLegalList, setCmsLegalList,
            cmsPersonalDataInfos, setCmsPersonalDataInfos,
            cmsPersonalDataList, setCmsPersonalDataList,
            cmsStepList, setCmsStepList,
            cmsStepInfos, setCmsStepInfos,
            countryList, setCountryList,
            data, setData,
            dataList, setDataList,
            documentList, setDocumentList,
            documentInfos, setDocumentInfos,
            documentTypeList, setDocumentTypeList,
            ensembleList, setEnsembleList,
            emailInfos, setEmailInfos,
            emailList, setEmailList,
            estimateCategoryInfos, setEstimateCategoryInfos,
            estimateCategoryList, setEstimateCategoryList,
            estimateContentInfos, setEstimateContentInfos,
            estimateDetails, setEstimateDetails,
            estimateLine, setEstimateLine,
            estimateSectionList, setEstimateSectionList,
            estimateSelectedSection, setEstimateSelectedSection,
            formId, setFormId,
            funerariumInfos, setFunerariumInfos,
            galleryContent, setGalleryContent,
            htmlInputContent, setHtmlInputContent,
            imageLib, setImageLib,
            singleImage, setSingleImage,
            legalFormList, setLegalFormList,
            networkContact, setNetworkContact,
            networkList, setNetworkList,
            networkMainInfos, setNetworkMainInfos,
            newProductList, setNewProductList,
            productInfos, setProductInfos,
            productList, setProductList,
            selectedCity, setSelectedCity,
            selectedBirthplace, setSelectedBirthplace,
            selectedDeathplace, setSelectedDeathplace,
            userInfos, setUserInfos,
        }}>
            { children }
        </DataContext.Provider>
    )
}

export default DataContext;